import axios from 'axios'

const API_URL = process.env.REACT_APP_NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL + "/api/notifications/" : '/api/notifications/';

// Get my notifications + unread count
const getNotifications = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.get(API_URL, config)
  return response.data
}

// Mark one notification as read
const markNotificationRead = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.post(API_URL + id + '/read', {}, config)
  return response.data
}

// Mark all notifications as read
const markAllNotificationsRead = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.post(API_URL + 'read-all', {}, config)
  return response.data
}

const notificationService = {
  getNotifications,
  markNotificationRead,
  markAllNotificationsRead,
}

export default notificationService
